<template>
    <div>
        <HeaderContent header="ข้อมูลลูกค้า" :img_header="header_image" link_back="content" />
        <ContentCustomerList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/rating.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import ContentCustomerList from '@/components/menuadmin/content/contentcustomer/ContentCustomerList.vue'

export default {
    name:'contentCustomer',
    components:{
        HeaderContent,
        ContentCustomerList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>